<!-- 标题组件 -->
<template>
  <div class="h-title" :class="{'special':specialType==='special'}">
    <img class="point" :src="iconPoint" alt="">
    <p class="text">{{text}}</p>
  </div>
</template>

<script>
export default {
  data () {
    return {
      iconPoint: require('static/images/point.png')
    }
  },
  props: {
    text: {
      type: String,
      required: true
    },
    specialType: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang='stylus' scoped>
.h-title
  margin 29px 0 25px 0
  height 18px
  display flex
  justify-content flex-start
  align-items center
  min-width 200px
  .point
    height 8px
    width 8px
    margin 0 11px 0 25px
    border-radius 4px
  .text
    font-size 18px
    color #fff
    height 18px
    line-height 18px
.special
  margin 29px 0 5px 0
</style>



// WEBPACK FOOTER //
// src/components/common/hTitle.vue